import "./footerCredit.css";

const DEVELOPER_NAME = "Wesley Vieira Martins";
const DISPLAY_PHONE = "27 99517-8250";
const WHATSAPP_NUMBER = "5527995178250";
const WHATSAPP_MESSAGE = "Olá Wesley, vi seu contato no site e gostaria de conversar sobre desenvolvimento de site ou sistema.";
const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(WHATSAPP_MESSAGE)}`;

function hideLockedEditorFields() {
  document.querySelectorAll(".site-editor-form label").forEach(label => {
    const firstText = [...label.childNodes].find(node => node.nodeType === Node.TEXT_NODE)?.textContent?.trim();
    if (firstText === "Crédito do desenvolvedor" || firstText === "Telefone do rodapé") {
      label.hidden = true;
      label.setAttribute("aria-hidden", "true");
    }
  });
}

function renderDeveloperCredit() {
  hideLockedEditorFields();
  const target = document.querySelector(".footer .footer-dev");
  if (!target) return;

  const currentLink = target.querySelector('a[data-developer-whatsapp="true"]');
  if (currentLink?.getAttribute("href") === WHATSAPP_URL && target.querySelector(".footer-dev-credit")) return;

  const raw = (target.textContent || "").replace(/\s+/g, " ").trim();
  const markerIndex = [raw.indexOf("Desenvolvedor"), raw.indexOf("Desenvolvido por")].filter(i => i >= 0).sort((a,b) => a-b)[0];
  const legalText = (markerIndex >= 0 ? raw.slice(0, markerIndex) : raw.split("·")[0]).replace(/[·\s]+$/g, "").trim() || "Todos os direitos reservados";

  const legal = document.createElement("span");
  legal.className = "footer-legal-fixed";
  legal.textContent = legalText;

  const creditRow = document.createElement("span");
  creditRow.className = "footer-credit-row";

  const credit = document.createElement("span");
  credit.className = "footer-dev-credit";
  credit.append("Desenvolvido por ");
  const name = document.createElement("strong");
  name.textContent = DEVELOPER_NAME;
  credit.append(name);

  const sep = document.createElement("span");
  sep.className = "footer-sep";
  sep.textContent = "·";

  const phone = document.createElement("a");
  phone.className = "footer-dev-phone";
  phone.href = WHATSAPP_URL;
  phone.target = "_blank";
  phone.rel = "noopener noreferrer";
  phone.dataset.developerWhatsapp = "true";
  phone.setAttribute("aria-label", `Falar com ${DEVELOPER_NAME} pelo WhatsApp`);
  phone.textContent = DISPLAY_PHONE;

  creditRow.append(credit, sep, phone);
  target.replaceChildren(legal, creditRow);
}

export function installDeveloperCredit() {
  const root = document.getElementById("root");
  if (!root) return () => {};
  const apply = () => queueMicrotask(renderDeveloperCredit);
  const observer = new MutationObserver(apply);
  observer.observe(root, { childList: true, subtree: true });
  apply();
  return () => observer.disconnect();
}
